import { AxiosError } from 'axios';
import { baseService } from 'services';
import {
  searchWorkFlowsEP,
  getWorkflowRunEP,
  getWorkflowRunLogsEP,
  getWorkflowRunStepsEP,
  pauseWorkflowEP,
  resumeWorkflowEP,
  cancelWorkflowEP,
  archiveWorkflowEP,
} from 'services/constants';
import {
  ISearchWorkFlowRequest,
  IGetWorkflowRunRequest,
  IGetWorkflowRunStepsRequest,
  IGetWorkflowRunLogsRequest,
  IWorkflowActionRequest,
  IWorkflowActionResponse,
  ISearchWorkflowResponse,
  IWorkflowRun,
  IGetWorkflowRunStepsResponse,
} from 'interface/workflowInterface';
import { ReliantResponse } from 'interface/apiInterface';

export const searchWorkflows = async (
  data: ISearchWorkFlowRequest,
): Promise<ReliantResponse<ISearchWorkflowResponse>> => {
  try {
    const response = await baseService.post<ISearchWorkflowResponse>(
      searchWorkFlowsEP,
      data,
    );
    return new ReliantResponse(response);
  } catch (error) {
    return new ReliantResponse(undefined, error as AxiosError);
  }
};

export const getWorkflowRun = async (
  data: IGetWorkflowRunRequest,
): Promise<ReliantResponse<IWorkflowRun>> => {
  try {
    const response = await baseService.post<IWorkflowRun>(
      getWorkflowRunEP,
      data,
    );
    return new ReliantResponse(response);
  } catch (error) {
    return new ReliantResponse(undefined, error as AxiosError);
  }
};

export const getWorkflowRunSteps = async (
  data: IGetWorkflowRunStepsRequest,
): Promise<ReliantResponse<IGetWorkflowRunStepsResponse>> => {
  try {
    const response = await baseService.post<IGetWorkflowRunStepsResponse>(
      getWorkflowRunStepsEP,
      data,
    );
    return new ReliantResponse(response);
  } catch (error) {
    return new ReliantResponse(undefined, error as AxiosError);
  }
};

export const getWorkflowRunLogs = async (data: IGetWorkflowRunLogsRequest) => {
  try {
    const response = await baseService.post(getWorkflowRunLogsEP, data);
    return new ReliantResponse(response);
  } catch (error) {
    return new ReliantResponse(undefined, error as AxiosError);
  }
};

export const resumeWorkflow = async (
  data: IWorkflowActionRequest,
): Promise<ReliantResponse<IWorkflowActionResponse>> => {
  try {
    const response = await baseService.post<IWorkflowActionResponse>(
      resumeWorkflowEP,
      data,
    );
    return new ReliantResponse(response);
  } catch (error) {
    return new ReliantResponse(undefined, error as AxiosError);
  }
};

export const pauseWorkflow = async (
  data: IWorkflowActionRequest,
): Promise<ReliantResponse<IWorkflowActionResponse>> => {
  try {
    const response = await baseService.post<IWorkflowActionResponse>(
      pauseWorkflowEP,
      data,
    );
    return new ReliantResponse(response);
  } catch (error) {
    return new ReliantResponse(undefined, error as AxiosError);
  }
};

export const cancelWorkflow = async (
  data: IWorkflowActionRequest,
): Promise<ReliantResponse<IWorkflowActionResponse>> => {
  try {
    const response = await baseService.post<IWorkflowActionResponse>(
      cancelWorkflowEP,
      data,
    );
    return new ReliantResponse(response);
  } catch (error) {
    return new ReliantResponse(undefined, error as AxiosError);
  }
};

export const archiveWorkflow = async (
  data: IWorkflowActionRequest,
): Promise<ReliantResponse<IWorkflowActionResponse>> => {
  try {
    const response = await baseService.post<IWorkflowActionResponse>(
      archiveWorkflowEP,
      data,
    );
    return new ReliantResponse(response);
  } catch (error) {
    return new ReliantResponse(undefined, error as AxiosError);
  }
};
